import { ArrayContainsValueBaseValueConverter } from 'General/Resources/ValueConverters/ArrayContainsValueBase';

export class ArrayContainsValueValueConverter extends ArrayContainsValueBaseValueConverter {
}